(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications-skeleton.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications-skeleton.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const TopHeader = svs.myProfile.react.shared.components.TopHeader;
const Skeleton = svs.myProfile.react.shared.components.Skeleton;
const _svs$myProfile$consta = svs.myProfile.constants,
  titles = _svs$myProfile$consta.titles,
  icons = _svs$myProfile$consta.icons;
const NotificationsSkeleton = () => {
  const _useState = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)),
    _useState2 = _slicedToArray(_useState, 1),
    isPlayerLoggedIn = _useState2[0];
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, React.createElement(TopHeader, {
    icon: icons.CORRECT,
    title: titles.CORRECT
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 4,
    boxWidthProcent: 100,
    topMargin: 2
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 80,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 80,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 1,
    boxHeight: 2,
    boxWidthProcent: 100,
    topMargin: 1
  }), isPlayerLoggedIn && React.createElement(React.Fragment, null, React.createElement(TopHeader, {
    icon: icons.PLAYTOGETHER,
    title: titles.PLAYTOGETHER
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 4,
    boxWidthProcent: 100,
    topMargin: 2
  }), React.createElement(TopHeader, {
    icon: icons.FRACTIONGAME,
    title: titles.FRACTIONGAME
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 4,
    boxWidthProcent: 100,
    topMargin: 2
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 2,
    boxWidthProcent: 100,
    topMargin: 1
  })));
};
svs.myProfile.react.pages.notifications.NotificationsSkeleton = NotificationsSkeleton;

 })(window);